import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const Field = ({ children, mods={} }) => {
    const { className } = useMods(Field, { mods });

    return (
        <div
            className={ className }
        >
            { children }
        </div>
    );
};

Field.displayName = 'Field';

Field.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object
};

export default Field;
